import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { CalculationStateService, CalculationOperation } from '../../../optimistic-planning/calculation-state.service';

@Component({
  selector: 'calculation-status-panel',
  templateUrl: './calculation-status-panel.component.html',
  styleUrls: ['./calculation-status-panel.component.scss']
})
export class CalculationStatusPanelComponent implements OnInit, OnDestroy {

  operations: CalculationOperation[] = [];
  private sub: Subscription;
  private tickSub: Subscription;

  // Current time for elapsed calculation
  now: number = Date.now();

  constructor(public calcState: CalculationStateService) {}

  ngOnInit() {
    this.sub = this.calcState.operations$.subscribe(ops => {
      this.operations = ops;
    });

    // Update elapsed times every second
    this.tickSub = interval(1000).subscribe(() => {
      this.now = Date.now();
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.tickSub?.unsubscribe();
  }

  get calculating(): CalculationOperation[] {
    return this.operations.filter(op => op.status === 'Calculating');
  }

  get completed(): CalculationOperation[] {
    return this.operations.filter(op => op.status === 'Completed');
  }

  get failed(): CalculationOperation[] {
    return this.operations.filter(op => op.status === 'Failed');
  }

  getElapsedSeconds(op: CalculationOperation): number {
    return Math.floor((this.now - new Date(op.startedAt).getTime()) / 1000);
  }

  getDurationSeconds(op: CalculationOperation): string {
    if (!op.durationMs) return '?';
    return (op.durationMs / 1000).toFixed(1);
  }

  getOperationLabel(op: CalculationOperation): string {
    const type = op.operationType || 'Plan';
    const count = op.planningBlockIds?.length || 0;
    const target = op.driverName
      ? `${op.driverName}${op.truckName ? ' / ' + op.truckName : ''}`
      : op.truckName || '';

    switch (type) {
      case 'plan':
        return `Plan ${count} block${count > 1 ? 's' : ''} → ${target}`;
      case 'move':
        return `Move TO → ${target}`;
      case 'assign':
        return `Assign capacity → ${target}`;
      default:
        return `${type} → ${target}`;
    }
  }

  dismiss(op: CalculationOperation) {
    this.calcState.dismissOperation(op.operationId).subscribe();
  }

  clearAllCompleted() {
    this.calcState.clearCompleted().subscribe();
  }
}
